export default __webpack_public_path__ + "static/ms-b049035cc6079c8482bad2b547690bf0.svg";